// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2fHPq","exit":"styles_exit__2bu-J","extra_button":"styles_extra_button__1X1iy"};